import React from 'react'
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { browserHistory } from 'react-router';

import NavLink from '../Routes/NavLink'

import { fees } from '../../core/controllers/Fees'
import FeeEdit from '../../components/Fee/FeeEdit';

export default class FeesList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fees: null,
            addFee: false,
            editFee: false,
            selected_id: 0
        };

        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        fees.getFees(function(response) {
            self.setState({
                fees: response.data
            })
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatLastLogin(cell, row) {
        return moment.utc(row.last_login).local().format('MMMM Do YYYY, h:mm:ss a');
    }

    formatJoinDate(cell, row) {
        if(cell) {
            return moment(cell).format('D MMM YYYY');
        } else {
            return 'Not Set';
        }
    }

    formatPercentage(cell, row) {
        return row.fee_percentage + "%";
    }

    addFee() {
        this.setState({editFee: false, addFee: true, selected_id: 0})
    }

    goBack() {
        var self = this;
        fees.getFees(function(response) {
            self.setState({
                fees: response.data,
                editFee: false, addFee: false, selected_id: 0
            })
        });
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        // format money
        var money = parseInt(value) / 100;
        money = Number(money.toFixed(2)).toLocaleString();
        if(money == 'NaN') { money = 0; }

        return money;
    }

    formatMoney(cell, row) {
        return '$' + this.formatAmount(cell);
    }

    formatGlobal(cell, row) {
        if (row.is_global == 1) {
            return 'Yes';
        } else {
            return 'No';
        }
    }

    didSelectRow(row) {
        this.setState({editFee: true, addFee: false, selected_id: row.fee_id})
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    render(){
        var self = this;
        var fees = this.state.fees;
        const addFee = this.state.addFee;
        const editFee = this.state.editFee;
        const feeId = this.state.selected_id;

        if(fees !== null) {
            fees = this.state.fees.map(function(owner) {
                return self.flattenObject(owner);
            });
        }

        const options = {
            onRowClick: this.didSelectRow.bind(this)
        };

        return (
            <div class="content">
                {addFee == true && editFee == false && (
                <div>
                    <FeeEdit goBack={this.goBack.bind(this)} newFee={true} feeId={0} />
                </div>
                )}
                {addFee == false && editFee == true && (
                <div>
                    <FeeEdit goBack={this.goBack.bind(this)} newFee={false} feeId={feeId} />
                </div>
                )}
                {addFee == false && editFee == false && (
                <div>
                    {fees != null ? (
                        window.innerWidth < 992 ? (
                        <BootstrapTable data={fees} version='4' striped search pagination hover options={options}>
                            <TableHeaderColumn dataField='fee_id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='fee_title' dataSort={ true }>Name</TableHeaderColumn>
                            <TableHeaderColumn dataField='fee_amount' dataFormat={this.formatMoney.bind(this)}  dataSort={ true }>Amount</TableHeaderColumn>
                            <TableHeaderColumn dataField='fee_perentage' dataFormat={this.formatPercentage} dataSort={ true }>Percentage</TableHeaderColumn>
                        </BootstrapTable>
                        ) : (
                        <BootstrapTable data={fees} version='4' striped search pagination hover options={options}>
                            <TableHeaderColumn dataField='fee_id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='fee_title' dataSort={ true }>Name</TableHeaderColumn>
                            <TableHeaderColumn dataField='fee_description' dataSort={ true }>Description</TableHeaderColumn>
                            <TableHeaderColumn dataField='is_global' dataFormat={this.formatGlobal.bind(this)}  dataSort={ true }>Global</TableHeaderColumn>
                            <TableHeaderColumn dataField='fee_amount' dataFormat={this.formatMoney.bind(this)}  dataSort={ true }>Amount</TableHeaderColumn>
                            <TableHeaderColumn dataField='fee_perentage' dataFormat={this.formatPercentage} dataSort={ true }>Percentage</TableHeaderColumn>
                            <TableHeaderColumn dataField='created_at' dataFormat={this.formatJoinDate} dataSort={ true }>Created</TableHeaderColumn>
                        </BootstrapTable>
                        )
                    ) : (
                        <p>No fees yet.</p>
                    )}
                    <div class="content">
                        <button type="button" id="add-tenant" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.addFee.bind(this)}>
                            Add Fee
                        </button>
                        <div class="clearfix"></div>
                    </div>
                </div>
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Fees/FeesList.jsx